import React, { ChangeEvent, useEffect, useState } from 'react';
import { Autocomplete, Box, Button, CircularProgress, Divider, Grid, IconButton, InputAdornment, Paper, Stack, Tab, Tabs, TextField, Typography } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { RoutesMap } from '../../types';
import { unmaskRUT } from '../../toolbox/helpers/rut-helper';
import logo from '../../assets/image/logo-softnet.png';
import logoheader from '../../assets/image/logopie.png';
import { Role } from '../../types/roles/roleTypes';
import { Formik } from 'formik';
import { useAuthStore } from '../../hooks/useAuthStore';
import './Login.css';
import { ForgetPasswordModal } from './components/modals/ForgetPasswordModal';
import { useUserStore } from '../../hooks/UseUserStore';
import { useCompanyStore } from '../../hooks/useCompanyStore';
import { company } from '../../types/slices/companyType';
import { ApiStatus } from '../../types/api/status';

const themeAvenir = createTheme({
    typography: {
        fontFamily: 'Avenir',
        fontSize: 15
    },
})

const roles = [
    { id: 1, name: 'Superadministrador' },
    { id: 2, name: 'Administrador' },
    // { id: 3, name: 'Vendedor' },
    // { id: 4, name: 'Equipo de Venta' },
    { id: 5, name: 'Cliente' },
    { id: 6, name: 'Comercial' },
]

type Values = {
    username: string,
    rut_company: string,
    password: string,
    iduser_type: number | undefined | null,
}

export const LoginView: React.FC<any> = (props: any): JSX.Element | any => {

    const navigate = useNavigate();
    const { login } = useAuthStore();
    const { forgotPassword } = useUserStore()
    const { status: statusCompany, companies, getCompanies } = useCompanyStore()

    const [companySelected, setCompanySelected] = useState<company | null>(null)
    const [loading, setLoading] = useState(false);
    const [selectedRol, setSelectedRol] = useState<any>('Administrador');
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [selectedRolNum, setSelectedRolNum] = useState<any>(2);
    const [data, setData] = useState<Values>({
        username: '',
        rut_company: '',
        password: '',
        iduser_type: 2,
    });
    const [forgetPassword, setForgetPassword] = useState<boolean>(false)

    useEffect(() => {
        getCompanies()
    }, [])

    const handleChangeTypeUser = (event: React.SyntheticEvent, role_user: string) => {
        switch (role_user) {
            case Role.SUPER_ADMIN:
                setData(prev => ({ ...prev, iduser_type: 1 }))
                setSelectedRolNum(1);
                break
            case Role.ADMIN:
                setData(prev => ({ ...prev, iduser_type: 2 }))
                setSelectedRolNum(2);
                break
            case Role.SALESMAN:
                setData(prev => ({ ...prev, iduser_type: 3 }))
                setSelectedRolNum(3);
                break
            case Role.EQUIPO_DE_VENTA:
                setData(prev => ({ ...prev, iduser_type: 4 }))
                setSelectedRolNum(4);
                break
            case Role.CLIENT:
                setData(prev => ({ ...prev, iduser_type: 5 }))
                setSelectedRolNum(5);
                break
            case Role.COMMERCIAL:
                setData(prev => ({ ...prev, iduser_type: 6 }))
                setSelectedRolNum(4);
                break
            default:
                setData(prev => ({ ...prev, iduser_type: 2 }))
                setSelectedRolNum(2);
                break
        }
        setSelectedRol(role_user);
    };

    const validateForm = (values) => {
        let errors: any = {};
        let regRut = /^[0-9]{8}[-|‐]{1}[0-9kK]{1}$/;
        if (!values.rut_company) errors.rut_company = "rut requerido";
        if (values.rut_company && !(regRut.test(values.rut_company))) errors.rut_company = "rut no válido";
        if (!values.password) errors.password = "contraseña requerida";
        return errors;
    }

    const handleClickShowPassword = () => {
        if (showPassword) setShowPassword(false)
        if (!showPassword) setShowPassword(true)
    }
    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
    }

    const createAccount = () => { }

    const onSubmit = async (values) => {
        const { username, rut_company, password, iduser_type } = values
        onSendLogin(username, rut_company, password, iduser_type)
    }

    const onSendLogin = async (username, rut_company, password, iduser_type) => {
        setLoading(true)
        try {
            const success: any = await login({ username, rut_company, password, iduser_type });

            if (!success?.status) {
                setLoading(false)
                return
            }

            let role = success?.detail?.userType;

            switch (role) {
                case Role.SUPER_ADMIN:
                    navigate({ pathname: RoutesMap.COMPANIES }, { replace: true })
                    break
                case (Role.ADMIN):
                    if (rut_company == "76868240-2") {
                        navigate({ pathname: RoutesMap.SEARCHER_COMPANY }, { replace: true })
                    } else {
                        navigate({ pathname: RoutesMap.USERS }, { replace: true })
                    }

                    break
                case Role.CLIENT:
                    navigate({ pathname: RoutesMap.SEARCHER_COMPANY }, { replace: true })
                    break;
                case Role.COMMERCIAL:
                    navigate({ pathname: RoutesMap.SEARCHER_COMPANY }, { replace: true })
                    break;
                case Role.SALESMAN:
                    navigate({ pathname: RoutesMap.SEARCHER_KFC }, { replace: true })
                    break
            }
            setLoading(false)
        } catch (error) {
            setData(prev => ({ ...prev, textError: 'Lo sentimos, ocurrió un error inesperado.' }))
            setLoading(false)
        }
    }

    const forgetPasswordSubmit = async (rut: string, rutCompany: string): Promise<void> => {
        let iduser_type: number = 2

        switch (selectedRol) {
            case Role.SUPER_ADMIN:
                iduser_type = 1
                break
            case Role.ADMIN:
                iduser_type = 2
                break
            case Role.CLIENT:
                iduser_type = 5
                break
            case Role.COMMERCIAL:
                iduser_type = 6
                break
            case Role.SALESMAN:
                iduser_type = 3
                break

            default:
                break
        }
        const unmaskedRUT = unmaskRUT(rut)
        const unmaskedRUTCompany = unmaskRUT(rutCompany)
        await forgotPassword({ rut: unmaskedRUT, iduser_type, rut_company: unmaskedRUTCompany })
    }

    return (
        <Box className='login-main-container'>
            <Grid container justifyContent="center">

                <Grid item xs={12} sx={{ backgroundColor: '#212D39', height: '60px' }}>
                    <Tabs
                        sx={{ maxWidth: { xs: 380, sm: 480, md: 800, lg: 800, xl: 800 }, color: '#FFF' }}
                        value={selectedRol}
                        onChange={handleChangeTypeUser}
                        variant="scrollable"
                        scrollButtons allowScrollButtonsMobile
                    >
                        {
                            roles && roles.map((role) => {
                                return (
                                    <Tab sx={{ color: '#fff', fontSize: '11px' }} value={role.name} label={role.name} />
                                )
                            })
                        }
                    </Tabs>
                </Grid>

                <Grid item xs={12} className='login-container' >
                    <Grid item xs={12} sm={12} md={5} lg={5}
                        sx={{ textAlign: { md: 'end', xs: 'start' }, display: { xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block' } }}>
                        <img style={{ width: '300px' }} src={logoheader} />
                        <img style={{ width: '300px' }} src={logo} />
                    </Grid>

                    <Grid item xs={12} sm={10} md={6} lg={5} sx={{ margin: '0px auto', minWidth: '200px' }}>
                        <Paper elevation={5} sx={{ borderRadius: '16px' }}>
                            <Grid xs={12} sx={{ height: '40px', backgroundColor: '#516E80', borderTopLeftRadius: '16px', borderTopRightRadius: '16px' }}></Grid>
                            <Grid sx={{ margin: { xs: '10px', sm: '10 px 20px', md: '10px 20px', lg: '10px 20px', xl: '10px 20px' } }}>
                                {/* Title */}
                                <Grid item xs={12} display="flex" justifyContent="center" textAlign="center">
                                    <Stack direction="row" justifyContent="start">
                                        <Typography variant='h5' color='#516E80' sx={{ fontWeight: 600, margin: '0px auto' }}>INGRESA TU USUARIO</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} display="flex" justifyContent="center" textAlign="center">
                                    <Stack direction="row" justifyContent="start">
                                        <Typography variant='body2' color='#808080' sx={{ fontWeight: 400, paddingBottom: 3 }}>Completa el formulario con tus datos:</Typography>
                                    </Stack>
                                </Grid>
                                <Formik initialValues={data} enableReinitialize validate={(values) => validateForm(values)} onSubmit={onSubmit}>
                                    {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                                        return (
                                            <form onSubmit={handleSubmit}>
                                                <ThemeProvider theme={themeAvenir}>
                                                    <Grid container spacing={2}>
                                                        <Grid item container xs={12} spacing={2}>
                                                            <Grid item xs={12}>
                                                                <TextField
                                                                    id="username"
                                                                    name='username'
                                                                    fullWidth
                                                                    variant='outlined'
                                                                    value={values.username}
                                                                    onChange={handleChange}
                                                                    placeholder='Nombre de usuario'
                                                                    size='small'
                                                                    type="text"
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <InputAdornment position='start'>
                                                                                <PersonIcon sx={{ color: '#29333B' }} />
                                                                            </InputAdornment>)
                                                                    }}
                                                                    error={errors.username && touched.username ? true : false}
                                                                    helperText={errors.username && touched.username ? errors.username : ''}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Autocomplete
                                                                    disablePortal
                                                                    id="combo-box-company"
                                                                    value={companySelected}
                                                                    options={statusCompany === ApiStatus.FETCHING ? [] : companies}
                                                                    getOptionLabel={(option) => option.business_name || ""}
                                                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                                    fullWidth
                                                                    renderInput={(params) =>
                                                                        <TextField
                                                                            {...params}
                                                                            size="small"
                                                                            placeholder='Empresa'
                                                                            InputProps={{
                                                                                ...params.InputProps,
                                                                                endAdornment: (
                                                                                    <React.Fragment>
                                                                                        {statusCompany === ApiStatus.FETCHING && <CircularProgress color="inherit" size={20} />}
                                                                                        {params.InputProps.endAdornment}
                                                                                    </React.Fragment>
                                                                                ),
                                                                                startAdornment: (
                                                                                    <InputAdornment position='start'>
                                                                                        <AssuredWorkloadIcon sx={{ color: '#29333B' }} />
                                                                                    </InputAdornment>)
                                                                            }}
                                                                        />
                                                                    }
                                                                    onChange={(e, newValue) => {
                                                                        setCompanySelected(newValue);
                                                                        setFieldValue('rut_company', newValue?.rut || '');
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <TextField
                                                                    id="password"
                                                                    name="password"
                                                                    fullWidth
                                                                    variant='outlined'
                                                                    type={showPassword ? 'text' : 'password'}
                                                                    value={values.password}
                                                                    onChange={handleChange}
                                                                    size='small'
                                                                    placeholder='Contraseña'
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <InputAdornment position='start'  >
                                                                                <LockIcon sx={{ color: '#29333B' }} />
                                                                            </InputAdornment>),
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                <IconButton
                                                                                    aria-label="toggle password visibility"
                                                                                    onClick={handleClickShowPassword}
                                                                                    onMouseDown={handleMouseDownPassword}
                                                                                    edge="end"
                                                                                    sx={{ color: '#29333B' }}
                                                                                >
                                                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                        )
                                                                    }}
                                                                    error={errors.password && touched.password ? true : false}
                                                                    helperText={errors.password && touched.password ? errors.password : ''}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} display="flex" justifyContent="center">
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        color: '#516E80',
                                                                        fontWeight: 500,
                                                                        cursor: 'pointer',
                                                                        '&:hover': {
                                                                            textDecoration: 'underline',
                                                                            color: '#365564'
                                                                        }
                                                                    }}
                                                                    onClick={() => setForgetPassword(true)}
                                                                >
                                                                    ¿Olvidaste tu contraseña?
                                                                </Typography>
                                                            </Grid>

                                                            <Grid item xs={12} display='flex' justifyContent='center'>
                                                                <Button
                                                                    type="submit"
                                                                    disabled={loading}
                                                                    fullWidth
                                                                    size="small"
                                                                    variant="contained"
                                                                    sx={{ width: '150px', background: '#73B2FF', color: '#fff', '&:hover': { bgcolor: '#007ea7' } }}
                                                                    onClick={() => { handleSubmit() }}
                                                                >
                                                                    {loading ? <CircularProgress size={28} /> : 'Continuar'}
                                                                </Button>
                                                            </Grid>

                                                            <Grid item xs={12} display='flex' justifyContent='center'>
                                                                <Button
                                                                    fullWidth
                                                                    size="small"
                                                                    variant="contained"
                                                                    sx={{ width: '150px', background: '#FFFFFF', color: '#73B2FF', border: 'solid 1px #73B2FF', '&:hover': { bgcolor: '#73B2FF', color: '#FFFFFF' } }}
                                                                >
                                                                    Crear cuenta
                                                                </Button>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                <Divider variant="middle" />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </ThemeProvider>
                                            </form>
                                        )
                                    }}
                                </Formik>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>

            {forgetPassword && (
                <ForgetPasswordModal
                    open={forgetPassword}
                    onClose={() => setForgetPassword(false)}
                    onSubmit={forgetPasswordSubmit}
                />
            )}
        </Box>
    )
}
